require.context('./', true).keys().forEach(function(name) {
    var jst = name.replace('./', 'templates/').replace('.jst.ejs', '');
    // Don't remove the '' before the name
    // https://github.com/webpack/webpack/issues/196#issuecomment-172775900
    JST[jst] = require('' + name);
});
